import type { GridCsvExportOptions } from "@mui/x-data-grid";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";

interface CustomToolbarProps {
  csvOptions?: GridCsvExportOptions;
}

export const CustomToolbar: React.FC<CustomToolbarProps> = ({ csvOptions }) => {
  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <GridToolbarExport csvOptions={csvOptions} />
    </GridToolbarContainer>
  );
};
